import { useEffect, useState } from 'react';
import type { MagneticWallItemSize } from './MagneticWallItem';
import { MAGNETIC_WALL_MIN_WIDTH } from './PostLayoutSizes';

function useMagneticWallItemSize(
  container: HTMLElement | null,
): MagneticWallItemSize {
  const [size, setSize] = useState<MagneticWallItemSize>('compact');

  useEffect(() => {
    if (!container) return undefined;

    function handleWidthChange(width: number) {
      if (width >= MAGNETIC_WALL_MIN_WIDTH) {
        setSize('full');
      } else {
        setSize('compact');
      }
    }

    handleWidthChange(container.offsetWidth);

    const resizeObserver = new ResizeObserver((entries) => {
      const entry = entries[0]?.contentRect;
      if (entry) {
        handleWidthChange(entry.width);
      }
    });
    resizeObserver.observe(container);
    return () => resizeObserver.disconnect();
  }, [container]);

  return size;
}

export default useMagneticWallItemSize;
